@if (metadata) {
  <div>
    <pre>{{ metadata | json }}</pre>
  </div>
}
